import { useState, useCallback, useRef } from 'react';
import { BackupAPI } from '../../../../../../utils/api';

export function useBackupActions() {
  const [exportStatus, setExportStatus] = useState(null); // null | 'loading' | 'done' | 'error'
  const [importStatus, setImportStatus] = useState(null); // null | 'loading' | 'done' | 'error' | { confirm, file, data }
  const fileInputRef = useRef(null);

  const handleExport = useCallback(async () => {
    setExportStatus('loading');
    try {
      const data = await BackupAPI.export();
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `fokus-backup-${new Date().toISOString().slice(0, 10)}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      setExportStatus('done');
      setTimeout(() => setExportStatus(null), 3000);
    } catch (err) {
      console.error('Export failed:', err);
      setExportStatus('error');
      setTimeout(() => setExportStatus(null), 4000);
    }
  }, []);

  const handleImportClick = useCallback(() => {
    fileInputRef.current?.click();
  }, []);

  const handleFileSelected = useCallback((e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    e.target.value = '';

    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        const data = JSON.parse(ev.target.result);
        if (data.version !== 1 || !Array.isArray(data.items)) {
          setImportStatus('error');
          setTimeout(() => setImportStatus(null), 4000);
          return;
        }
        setImportStatus({ confirm: true, file: file.name, data });
      } catch {
        setImportStatus('error');
        setTimeout(() => setImportStatus(null), 4000);
      }
    };
    reader.readAsText(file);
  }, []);

  const handleImportConfirm = useCallback(async () => {
    if (!importStatus?.data) return;
    const data = importStatus.data;
    setImportStatus('loading');
    try {
      await BackupAPI.import(data, 'overwrite');
      setImportStatus('done');
      setTimeout(() => setImportStatus(null), 3000);
    } catch (err) {
      console.error('Import failed:', err);
      setImportStatus('error');
      setTimeout(() => setImportStatus(null), 4000);
    }
  }, [importStatus]);

  return {
    fileInputRef,
    exportStatus,
    importStatus,
    setImportStatus,
    handleExport,
    handleImportClick,
    handleFileSelected,
    handleImportConfirm,
  };
}
